// OfferDetailsModalHandler intention is to keep a generic way of importing modal
// and to keep modal logic and flows inside one single component to prevent duplicated logic/code within pages.

import React, { useEffect, useContext, useCallback } from 'react'
import OfferDetailsModal from '../OfferDetailsModal/OfferDetailsModal'
import { modalContext } from '../../../../../contexts/ModalContext/ModalContext'
import { sendFptiClick, FptiEventNames } from '../../../../../lib/fpti-pa'
import {
  MODAL_OPEN_STATUS,
  MODAL_CONTEXT_OFFER_DETAILS_OPEN_ACTION,
  MODAL_CONTEXT_OFFER_DETAILS_CLOSE_ACTION
} from '../../../../../lib/client-constants'

type Props = {
  fptiSource: string
  fptiPage?: string
  fptiPgrp?: string
  fptiCloseEvent?: FptiEventNames
}

const OfferDetailsModalHandler = ({
  fptiSource,
  fptiCloseEvent,
  fptiPage,
  fptiPgrp
}: Props) => {
  const { state: modalState, dispatch } = useContext(modalContext)

  useEffect(() => {
    //Open Offer Details modal with query params logic
    const queryParams = new URLSearchParams(window.location.search)
    const honeyOfferIdQueryParam = queryParams.get('honeyOfferId')
    const honeyStoreIdQueryParam = queryParams.get('honeyStoreId')
    const isHoneyOffer = honeyOfferIdQueryParam && honeyStoreIdQueryParam
    if (isHoneyOffer) {
      dispatch({
        type: MODAL_CONTEXT_OFFER_DETAILS_OPEN_ACTION,
        payload: {
          honeyOfferId: honeyOfferIdQueryParam,
          honeyStoreId: honeyStoreIdQueryParam
        }
      })
    }
  }, [dispatch])

  const handleOfferDetailsModalClose = useCallback(() => {
    dispatch({ type: MODAL_CONTEXT_OFFER_DETAILS_CLOSE_ACTION })
    if (fptiCloseEvent) {
      sendFptiClick({
        event_name: fptiCloseEvent,
        page: fptiPage,
        pgrp: fptiPgrp
      })
    }
  }, [fptiCloseEvent, fptiPage, fptiPgrp, dispatch])

  const isOpen = modalState.offerDetailsModal.status === MODAL_OPEN_STATUS

  if (!isOpen) {
    return null
  }

  return (
    <OfferDetailsModal
      isOpen={isOpen}
      onClose={handleOfferDetailsModalClose}
      honeyOfferId={modalState.offerDetailsModal.honeyOfferId}
      honeyStoreId={modalState.offerDetailsModal.honeyStoreId}
      fptiSource={fptiSource}
    />
  )
}

export default OfferDetailsModalHandler
